import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";

const MilagritoSwitch = withStyles({
	switchBase: {
		color: "darkgray",
		"&$checked": {
			color: "#52d869",
		},
		"&$checked + $track": {
			backgroundColor: "#52d869",
		},
	},
	checked: {},
	track: {
		backgroundColor: "gray",
	},
})(Switch);

export default function CustomCheckbox(props) {
	const { handleChange, value = false, data } = props;
	const { label, id } = data;

	return (
		<FormControlLabel
			control={<MilagritoSwitch checked={value} onChange={handleChange} name={id} />}
			label={label}
			labelPlacement="start"
		/>
	);
}
